(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["root-eraser-cards"] && !Shopify.designMode) return;
  try {
    
function initRootEraserReviews(scope){
  scope.querySelectorAll('.re-cards--reviews').forEach(function(section){
    if(section.dataset.reReviewsReady==='true')return;
    section.dataset.reReviewsReady='true';
    const button=section.querySelector('[data-re-review-toggle]');
    if(!button)return;
    button.addEventListener('click',function(){
      const expanded=section.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded',expanded?'true':'false');
      button.textContent=expanded?'Show fewer reviews':'Show more reviews';
    });
  });
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>initRootEraserReviews(document));
}else{
  initRootEraserReviews(document);
}
document.addEventListener('shopify:section:load',event=>initRootEraserReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["root-eraser-hero"] && !Shopify.designMode) return;
  try {
    
function initRootEraserHero(root){
  if(root.dataset.reBound)return;
  root.dataset.reBound='true';

  const thumbs=[...root.querySelectorAll('[data-re-thumb]')];
  const main=root.querySelector('.re-hero__main-image');
  const empty=root.querySelector('[data-re-empty]');
  const variantInput=root.querySelector('[data-re-variant-id]');
  const quantityInput=root.querySelector('[data-re-quantity]');
  const buy=root.querySelector('[data-re-buy]');
  const form=root.querySelector('form');
  const tierCards=[...root.querySelectorAll('[data-re-tier-card]')];
  const tierRadios=[...root.querySelectorAll('[data-re-tier]')];
  const brushToggles=[...root.querySelectorAll('[data-re-brush-toggle]')];
  const sticky=root.querySelector('[data-re-sticky]');
  let selected=0;

  function show(i){
    if(!thumbs.length)return;
    selected=(i+thumbs.length)%thumbs.length;
    const thumb=thumbs[selected];
    const source=thumb.dataset.image;
    if(source){
      main.hidden=false;
      main.removeAttribute('srcset');
      main.src=source;
      main.alt=thumb.dataset.alt||'';
      empty.hidden=true;
    }else{
      main.hidden=true;
      main.removeAttribute('src');
      main.alt='';
      empty.hidden=false;
    }
    const title=root.querySelector('[data-re-gallery-title]');
    const caption=root.querySelector('[data-re-gallery-caption]');
    if(title)title.textContent=thumb.dataset.title||'Product photograph';
    if(caption)caption.textContent=thumb.dataset.caption||'Image to be added';
    thumbs.forEach(item=>item.classList.toggle('is-active',item===thumb));
  }

  function optionFor(select){
    return select?.selectedOptions?.[0]||null;
  }

  function syncShadeSelect(select,showVariantImage){
    const option=optionFor(select);
    if(!option)return;
    const row=select.closest('.re-hero__bundle-shade-row');
    const swatch=row?.querySelector('[data-re-unit-swatch]');
    if(swatch)swatch.style.backgroundColor=option.dataset.color||'#6A5142';

    if(showVariantImage && option.dataset.image && root.dataset.reShowProductMedia==='true'){
      main.hidden=false;
      main.removeAttribute('srcset');
      main.src=option.dataset.image;
      main.alt=option.dataset.alt||'';
      empty.hidden=true;
    }
  }

  function getActiveCard(){
    return tierCards.find(card=>card.classList.contains('is-active'))||tierCards[0]||null;
  }

  function updateSticky(){
    if(!sticky)return;
    const card=getActiveCard();
    if(!card)return;
    const titleEl=card.querySelector('.re-hero__quantity-title');
    const priceEl=card.querySelector('.re-hero__quantity-price strong');
    const titleText=titleEl&&titleEl.childNodes[0]?titleEl.childNodes[0].textContent.trim():'';
    const stickyTitle=sticky.querySelector('[data-re-sticky-title]');
    const stickyPrice=sticky.querySelector('[data-re-sticky-price]');
    if(stickyTitle)stickyTitle.textContent=titleText;
    if(stickyPrice)stickyPrice.textContent=priceEl?priceEl.textContent.trim():'';
  }

  function syncAvailability(){
    const card=getActiveCard();
    if(!card)return;
    const selects=[...card.querySelectorAll('[data-re-unit-variant]')];
    const unavailable=selects.some(select=>optionFor(select)?.dataset.available!=='true');
    if(buy)buy.disabled=unavailable;
    const first=optionFor(selects[0]);
    if(first && variantInput)variantInput.value=first.value;
    if(quantityInput)quantityInput.value=card.dataset.quantity||'1';
  }

  function activateTier(radio){
    tierCards.forEach(card=>{
      const ownRadio=card.querySelector('[data-re-tier]');
      card.classList.toggle('is-active',ownRadio===radio);
    });
    const card=radio.closest('[data-re-tier-card]');
    card?.querySelectorAll('[data-re-unit-variant]').forEach(select=>syncShadeSelect(select,false));
    syncAvailability();
    updateSticky();
  }

  if(thumbs.length)show(0);
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
  root.querySelector('[data-re-prev]')?.addEventListener('click',()=>show(selected-1));
  root.querySelector('[data-re-next]')?.addEventListener('click',()=>show(selected+1));

  root.querySelectorAll('[data-re-unit-variant]').forEach(select=>{
    syncShadeSelect(select,false);
    select.addEventListener('change',()=>{
      syncShadeSelect(select,true);
      syncAvailability();
    });
  });

  tierRadios.forEach(radio=>radio.addEventListener('change',()=>activateTier(radio)));

  let checked=tierRadios.find(radio=>radio.checked);
  if(!checked && tierRadios.length){
    checked=tierRadios[0];
    checked.checked=true;
  }
  if(checked)activateTier(checked);

  brushToggles.forEach(toggle=>toggle.addEventListener('change',()=>{
    brushToggles.forEach(other=>{
      if(other!==toggle && !other.disabled)other.checked=toggle.checked;
    });
  }));

  if(sticky && buy){
    updateSticky();
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{sticky.hidden=entry.isIntersecting;});
      });
      observer.observe(buy);
    }else{
      sticky.hidden=false;
    }
    sticky.querySelector('[data-re-sticky-buy]')?.addEventListener('click',()=>{
      if(buy.disabled){
        buy.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      buy.click();
    });
  }

  form?.addEventListener('submit',async event=>{
    event.preventDefault();
    const card=getActiveCard();
    if(!card)return;

    const selects=[...card.querySelectorAll('[data-re-unit-variant]')];
    const counts=new Map();
    for(const select of selects){
      const option=optionFor(select);
      if(!option || option.dataset.available!=='true'){
        alert('One of the selected shades is unavailable. Please choose another shade.');
        return;
      }
      const id=Number(option.value);
      counts.set(id,(counts.get(id)||0)+1);
    }

    const items=[...counts.entries()].map(([id,quantity])=>({id,quantity}));
    const brushChecked=brushToggles.some(toggle=>toggle.checked && !toggle.disabled);
    const brushToggle=brushToggles.find(toggle=>toggle.dataset.brushId);
    if(brushChecked && brushToggle){
      items.push({id:Number(brushToggle.dataset.brushId),quantity:1});
    }

    if(!items.length)return;
    buy.disabled=true;

    try{
      const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      if(!response.ok){
        const data=await response.json().catch(()=>({}));
        throw new Error(data.description||'Please try adding your selection again.');
      }
      window.location.href=(window.Shopify?.routes?.root||'/')+'cart';
    }catch(error){
      buy.disabled=false;
      alert(error.message);
    }
  });
}

function initAllRootEraserHeroes(scope){
  scope.querySelectorAll('.re-hero').forEach(initRootEraserHero);
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>initAllRootEraserHeroes(document));
}else{
  initAllRootEraserHeroes(document);
}
document.addEventListener('shopify:section:load',event=>initAllRootEraserHeroes(event.target));

  } catch(e) { console.error(e); }
})();
})();
